export default defineNuxtRouteMiddleware(async (to, from) => {
  // Get waitlist config
  const config = useRuntimeConfig()
  const waitlistEnabled = config.public.waitlist?.enabled ?? true

  // Skip middleware if waitlist is disabled
  if (!waitlistEnabled) {
    return
  }

  // Skip for certain routes
  const publicRoutes = [
    '/waitlist',
    '/invite',
    '/api',
    '/login',
    '/privacy',
    '/terms',
  ]
  const isPublicRoute = publicRoutes.some((route) => to.path.startsWith(route))

  if (isPublicRoute) {
    return
  }

  // Check if user is logged in and active
  const userStore = useState('user')
  if (userStore.value?.isLoggedIn && userStore.value?.isActive) {
    return
  }

  // Check if user is on waitlist - get email from query param or cookie
  const emailFromQuery = to.query.email as string
  const emailFromCookie = useCookie('waitlist_email').value
  const email = emailFromQuery || emailFromCookie

  if (email) {
    try {
      const { data } = await useFetch('/api/waitlist/status', {
        method: 'POST',
        body: { email },
      })

      if (data.value?.success) {
        // If user is active, update user store
        if (data.value.status === 'active' && data.value.isActive) {
          if (userStore.value) {
            userStore.value.isLoggedIn = true
            userStore.value.isActive = true
            userStore.value.email = email
          }

          // Store the email in cookie for future reference if not already set
          if (!emailFromCookie) {
            const waitlistEmailCookie = useCookie('waitlist_email', {
              maxAge: 60 * 60 * 24 * 30, // 30 days
              path: '/',
            })
            waitlistEmailCookie.value = email
          }

          return
        }

        // If user is on waitlist, redirect to waitlist page
        if (data.value.waitlist) {
          return navigateTo('/waitlist')
        }
      }
    } catch (error) {
      console.error('Error checking waitlist status:', error)
    }
  }

  // Default redirection to waitlist page
  return navigateTo('/waitlist')
})
